import { Box, Paper, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { DASHBOARD_INK } from "../../utils/dashboardTokens";

type Props = {
	title: string;
	subtitle: string;
	footer?: string;
	children: ReactNode;
};

export const DashboardCard = ({ title, subtitle, footer, children }: Props) => (
	<Paper
		elevation={0}
		sx={{
			border: 1,
			borderColor: "divider",
			borderRadius: 1,
			display: "flex",
			flexDirection: "column",
			height: "100%",
			p: 2,
		}}
	>
		<Box
			sx={{
				alignItems: "baseline",
				columnGap: 1,
				display: "flex",
				flexWrap: "wrap",
				mb: 1,
			}}
		>
			<Typography
				sx={{
					color: DASHBOARD_INK.PRIMARY,
					fontSize: "1rem",
					fontWeight: 600,
				}}
			>
				{title}
			</Typography>
			<Typography
				sx={{
					color: DASHBOARD_INK.MUTED,
					fontSize: "0.8125rem",
					fontVariantNumeric: "tabular-nums",
				}}
			>
				{subtitle}
			</Typography>
		</Box>
		{children}
		{footer && (
			<Typography
				sx={{
					color: DASHBOARD_INK.MUTED,
					fontSize: "0.75rem",
					lineHeight: 1.5,
					mt: "auto",
					pt: 1,
				}}
			>
				{footer}
			</Typography>
		)}
	</Paper>
);
